import React from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route } from 'react-router-dom'
import ProtectedRoute from '../../internal/ProtectedRoute'
import StoreSelect from './StoreSelect'
import { Authorities } from '../../models/authorities'
import { usePagination } from '../../provider/PaginationProvider'

const StoreSelectRoutes = ({ loggedIn, selectStore }) => {
  const { resetPaginationData } = usePagination()
  let route = null
  if (loggedIn && selectStore) {
    route = <StoreSelect resetPaginationData={resetPaginationData} />
  } else if (loggedIn) {
    route = <Redirect to="/" />
  } else {
    route = <Redirect to="/login" />
  }

  return [
    <Route
      key="/store/select"
      exact
      path="/store/select"
      render={() => {
        return route
      }}
    />,
    <ProtectedRoute
      key="/store/change"
      exact
      path="/store/change"
      authority={Authorities.SET_STORE}
      page={<StoreSelect resetPaginationData={resetPaginationData} />}
    />,
  ]
}

StoreSelectRoutes.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
  selectStore: PropTypes.bool.isRequired,
}

export default StoreSelectRoutes
